/**
 * Bounds for template `regexRule` execution on the UI thread (CWE-1333 / ReDoS).
 * Alert #28 / ACME-1899: cap tested value length before regex.test.
 */

/** Cap `regex.test` input so a catastrophic pattern cannot hang the tab. */
export const REGEX_RULE_MAX_TEST_VALUE_LENGTH = 1024;

/** Generate dialog: syntactically invalid regex stored on the template variable. */
export const INVALID_TEMPLATE_REGEX_SYNTAX_MESSAGE =
  "Invalid regex syntax for this variable. Edit this template's Settings tab and fix the Regex field.";
